/**
 * user模块接口列表
 */
// import base from './base';
import {backendUrl} from '@/assets/js/config'
import axios from '@/assets/plugins/axios'
let headers = {'Content-type': 'application/x-www-form-urlencoded'}

const user = {
  // 获取
  queryUserList (params) {
    return axios.get(`${backendUrl}/api/user/list`, params)
  },
  // 提交
  addUser (params) {
    return axios.post('/api/user/add', params)
  },
  // 心跳检测session 是否失效
  checkSession (params) {
    return axios.get(`${backendUrl}/user/check_session`, params)
  },

  // 检查隐私协议 授权情况
  checkPrivacy () {
    return axios.get(`${backendUrl}/user/privacy`)
  },

  // 设置隐私协议 授权情况
  setPrivacy (params) {
    return axios.post(`${backendUrl}/user/privacy`, params, headers)
  },

  // x. 退出登录
  logout () {
    return axios.get(`${backendUrl}/user/logout`)
  },

  // 退出单点登录
  accountLogout (params) {
    return axios.get(`${backendUrl}/user/account_logout`, params)
  },

  // 广材网 退出
  gldjcLogout () {
    return axios.get('https://gldjc.com/logout')
  },

  // 导入个人账号，用户名密码验证
  validateAccount (params) {
    return axios.post(`${backendUrl}/user/verify-person`, params)
  },

  // 导入个人工程
  importPersonProject (params) {
    return axios.post(`${backendUrl}/file/copy/person`, params)
  },

  // 导入个人数据
  importPersonData (params) {
    return axios.post(`${backendUrl}/data_manage/import-userdata`, params)
  },

  // 绑定手机
  postPasswordMobile (params) {
    return axios.post(`${backendUrl}/user/password-mobile?uniqueness=true`, params, headers)
  }

}

export default user
